import { useEffect, useRef, useState } from "react";
import "leaflet/dist/leaflet.css";
import L from "leaflet";
import markerIcon2x from "leaflet/dist/images/marker-icon-2x.png";
import markerIcon from "leaflet/dist/images/marker-icon.png";
import markerShadow from "leaflet/dist/images/marker-shadow.png";
import Constantes from "../constantes";

// Configurar iconos por defecto de Leaflet
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: markerIcon2x,
  iconUrl: markerIcon,
  shadowUrl: markerShadow,
});

function MiniMapa({ lat, lon }) {
  const mapRef = useRef(null);
  const userMarkerRef = useRef(null);
  const poiLayerRef = useRef(null);

  const [monumentos, setMonumentos] = useState([]);

  // Cargar monumentos
  const cargarMonumentos = async (lat, lon) => {
    try {
      // Corregido: enviar latitud y altitud correctamente
      const res = await fetch(
        `${Constantes.RUTA_API}/monumentos/getMonumento?latitud=${lon}&altitud=${lat}`,
        { credentials: "include" }
      );

      const data = await res.json();

      if (Array.isArray(data)) setMonumentos(data);
      else if (Array.isArray(data.monumentos)) setMonumentos(data.monumentos);
      else if (Array.isArray(data.data)) setMonumentos(data.data);
      else setMonumentos([]);

    } catch (err) {
      console.error("Error cargando monumentos:", err);
      setMonumentos([]);
    }
  };

  // Crear mapa / mover usuario
  useEffect(() => {
    if (!lat || !lon) return;

    if (!mapRef.current) {
      mapRef.current = L.map("mini-mapa", {
        center: [lat, lon],
        zoom: 13,
        scrollWheelZoom: true,
      });

      L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
        attribution: "&copy; OpenStreetMap contributors",
      }).addTo(mapRef.current);

      poiLayerRef.current = L.layerGroup().addTo(mapRef.current);
    } else {
      mapRef.current.setView([lat, lon], 13);
    }

    // Marcador usuario
    if (userMarkerRef.current) {
      userMarkerRef.current.setLatLng([lat, lon]);
    } else {
      userMarkerRef.current = L.marker([lat, lon]).addTo(mapRef.current);
    }

    cargarMonumentos(lat, lon);
  }, [lat, lon]);

  // Dibujar POI
  useEffect(() => {
    if (!poiLayerRef.current) return;

    poiLayerRef.current.clearLayers();

    // Icono rojo personalizado
    const redIcon = new L.Icon({
      iconUrl: "https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/marker-icon-red.png",
      shadowUrl: markerShadow,
      iconSize: [25, 41],
      iconAnchor: [12, 41],
      popupAnchor: [1, -34],
      shadowSize: [41, 41],
    });

    monumentos.forEach((m) => {
      // Validar coordenadas correctamente
      if (m.latitud == null || m.altitud == null) return;

      L.marker([m.altitud, m.latitud], { icon: redIcon })
        .addTo(poiLayerRef.current)
        .bindPopup(`
          <b>${m.nombre}</b><br/>
          ${m.imagen_url ? `<img src="${m.imagen_url}" width="120"/>` : ""}
        `);
    });
  }, [monumentos]);

  return (
    <div
      id="mini-mapa"
      style={{ height: "350px", width: "100%", marginTop: "10px" }}
    />
  );
}

export default MiniMapa;